module.exports = __webpack_public_path__ + "static/media/calendar.f3bfe8e9.png";